"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeOneOrAll = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ChangeOneOrAll = function ChangeOneOrAll(_ref) {
  var actionText = _ref.actionText,
    value = _ref.value,
    onActionSelect = _ref.onActionSelect;
  var handleActionSelect = function handleActionSelect(e) {
    var action = e.target.value;
    onActionSelect(action);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[12px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Radio.Group, {
    name: "manageAppointmentTarget",
    onChange: handleActionSelect,
    value: value
  }, /*#__PURE__*/_react.default.createElement(_components.Radio, {
    value: _utils.ManageAppointmentTarget.One
  }, actionText, " this appointment only"), /*#__PURE__*/_react.default.createElement(_components.Radio, {
    value: _utils.ManageAppointmentTarget.All
  }, actionText, " all appointments")));
};
exports.ChangeOneOrAll = ChangeOneOrAll;